import React from "react";

const Contact = () => {
  return (
    <div className="App">
      <h1>Contact</h1>
      <h2>
        Contact me at:{" "}
        <a href="mailto:dbmangrum@gmail.com">Dalton B. Mangrum</a>
      </h2>
    </div>
  );
};

export default Contact;
